import { connect } from 'react-redux';
import { PaymentCardType } from '@mews/enums';
import { ApplicationState } from '@mews-commander/types';
import {
    getSurchargeFee,
    getSurchargeServiceId,
} from '@mews-commander/legacy-entities/src/ducks/accountingConfigurations';

interface StateProps {
    serviceId: string;
    feePercent: number;
}

interface OwnProps {
    enterpriseId: string;
    paymentCardType: PaymentCardType;
}

export const connectSurchargePercentLabel = connect<StateProps, {}, OwnProps, ApplicationState>(
    (state: ApplicationState, { enterpriseId, paymentCardType }: OwnProps) => {
        const surchargeServiceId = getSurchargeServiceId(state, { enterpriseId });
        return {
            serviceId: surchargeServiceId,
            // @ts-expect-error $TSFixMeError: Argument of type '{ enterpriseId: string; paymentCardType: PaymentCardType; }' is not assignable to parameter of type '{...
            feePercent: getSurchargeFee(state, { enterpriseId, paymentCardType }),
        };
    }
);
